"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uncrunch = void 0;
const JSON_1 = require("../JSON");
function uncrunch(values) {
  const expanded = [];
  const lookup = i => expanded[i];
  expanded.length = values.length; // Hint at array length for perf boost.
  for (let i = 0; i < values.length; i++) {
    const value = values[i];
    expanded[i] = (0, JSON_1.isContainer)(value) ? (0, JSON_1.map)(value, lookup) : value;
  }
  return expanded[expanded.length - 1];
}
exports.uncrunch = uncrunch;